import { useState } from "react";
import { toast } from "react-toastify";
import api from "../../api/axiosInstance";
const ChangePassword = () => {
  const [password, setPassword] = useState({});

  const checked = () => {
    if (password.oldPassword == null || password.oldPassword == "") {
      toast.warn("Enter old password");
      return false;
    } else if (password.newPassword == null || password.newPassword == "") {
      toast.warn("Enter new password");
      return false;
    } else if (
      password.confirmPassword == null ||
      password.confirmPassword == ""
    ) {
      toast.warn("Enter confirm password");
      return false;
    } else if (
      password.newPassword != null &&
      password.confirmPassword != null
    ) {
      if (password.newPassword != password.confirmPassword) {
        toast.warn("New Password and Confirm Password don't meet");
        return false;
      }
    }
    return true;
  };

  const handleChangePassword = () => {
    if (checked()) {
      var config = {
        method: "Post",
        url:
          process.env.REACT_APP_API_URL +
          "Users/ChangePassword/" +
          localStorage.getItem("uTsReD"),
        headers: {
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        data: password,
      };

      api(config).then(function (response) {
        console.log(response);
        if (response.data.statusCode == 200) {
          toast.success("Password Updated");
          setPassword({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        } else {
          toast.error("Make sure that old password is correct");
        }
      });
    }
  };

  return (
    <div className="container-fluid mt-30">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Change Password</h3>
              <div className="align-self-center"></div>
            </div>
            <div className="card-body">
              {/* <div class="alert alert-primary" role="alert">
                
              </div> */}
              <div className="row">
                <div className="col-md-2 text-right">
                  <h6 style={{ lineHeight: "31px" }} className="mb-1">
                    Old Password
                  </h6>
                  <h6 style={{ lineHeight: "31px" }} className="mb-1">
                    New Password
                  </h6>
                  <h6 style={{ lineHeight: "31px" }} className="mb-1">
                    Confirm Password
                  </h6>
                </div>
                <div className="col-md-2">
                  <input
                    className="form-control form-control-sm mb-1"
                    placeholder="Old Password"
                    type="password"
                    value={password.oldPassword}
                    onChange={(e) =>
                      setPassword((prevState) => ({
                        ...prevState,
                        oldPassword: e.target.value,
                      }))
                    }
                  />

                  <input
                    className="form-control form-control-sm mb-1"
                    placeholder="New Password"
                    type="password"
                    value={password.newPassword}
                    onChange={(e) =>
                      setPassword((prevState) => ({
                        ...prevState,
                        newPassword: e.target.value,
                      }))
                    }
                  />

                  <input
                    className="form-control form-control-sm mb-1"
                    placeholder="Confirm Password"
                    type="password"
                    value={password.confirmPassword}
                    onChange={(e) =>
                      setPassword((prevState) => ({
                        ...prevState,
                        confirmPassword: e.target.value,
                      }))
                    }
                  />
                  <button
                    className="btn btn-success btn-sm mt-10"
                    onClick={() => handleChangePassword()}
                  >
                    Change Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
